<template>
  <el-dialog
    title="Заявки на оценку коллег"
    :visible.sync="show"
    top="2vh"
    :close-on-click-modal="false"
    width="90%"
  >
    <div v-loading="loading">
      <div style="margin-bottom: 25px; display: flex; justify-content: space-between">
        <div>
          <search-input
            placeholder="Поиск по ФИО"
            style="width: 300px"
            v-model="filters.search"
            @change="filtersChanged"
          >
          </search-input>
          <el-switch
            style="margin-left: 20px"
            v-model="filters.all"
            :active-value="1"
            :inactive-value="0"
            active-text="Показать добавленных"
            @change="filtersChanged"
          >
          </el-switch>
        </div>
        <el-button
          type="primary"
          size="small"
          icon="fas fa-plus"
          @click="openAddDialog"
        >
          Добавить ещё коллег
        </el-button>
      </div>
      <el-table
        :data="evaluators"
        border
        ref="selectEvaluatorsTable"
        :row-key="(row) => row.id"
      >
        <el-table-column type="selection" reserve-selection width="55" :selectable="checkSelectable"></el-table-column>
        <el-table-column width="150" prop="user.persnum" label="Перс. №"></el-table-column>
        <el-table-column prop="user.full_name" label="ФИО"></el-table-column>
        <el-table-column prop="user.email" label="Email"></el-table-column>
        <el-table-column prop="status_label" label="Статус"></el-table-column>
        <el-table-column
          v-if="evaluation.setting && evaluation.setting.is_colleague_auto_approval"
          label="Осталось дней на согласование"
        >
          <template v-slot="scope">
            {{ scope.row.status === 'manage_request' ? getRemainingDays(scope.row.created_at, evaluation.setting.colleague_auto_approval_days) : '' }}
          </template>
        </el-table-column>
      </el-table>
      <paginator
        :paginator.sync="paginator"
        use-router-query-param
        @page-changed="loadEvaluators"
      ></paginator>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button size="small" @click="show = false">Отмена</el-button>
      <el-button
        :disabled="$refs.selectEvaluatorsTable && !$refs.selectEvaluatorsTable.selection.length"
        :loading="loading"
        type="primary"
        @click="addSelectedRequests(0)"
        size="small"
        icon="fas fa-plus"
      >
        Согласовать отмеченных
      </el-button>
      <el-button
        :disabled="!isActiveRequest"
        :loading="loading"
        type="primary"
        @click="addSelectedRequests(1)"
        size="small"
        icon="fas fa-plus"
      >
        Согласовать всех
      </el-button>
      <el-button
        :disabled="!isActiveRequest"
        :loading="loading"
        type="primary"
        @click="addSelectedRequests(0, 1)"
        size="small"
        icon="fas fa-plus"
      >
        Отклонить всех
      </el-button>
    </div>

    <add-eval-colleagues-dialog
      ref="addDialog"
      :all="true"
      :user_id="evaluateeId"
      :evaluation="evaluation"
      @load-evaluators="loadEvaluators"
    >
    </add-eval-colleagues-dialog>
  </el-dialog>
</template>

<script>
import {off, on} from "element-ui/src/utils/dom";
import Paginator from "@/components/Paginator";
import {paginator} from "@/mixins/paginator";
import SearchInput from "@/components/filters/SearchInput.vue";
import AddEvalColleaguesDialog from "@/modules/evaluation/components/myEvaluation/AddEvalColleaguesDialog.vue";

export default {
  name: "eval-user-requests-dialog",
  components: {AddEvalColleaguesDialog, SearchInput, Paginator},
  mixins: [paginator],
  beforeMount() {
    this.paginator.perPage = 10;
  },
  data() {
    return {
      loading: false,
      evaluateeId: null,
      isActiveRequest: false,
      evaluationId: null,
      evaluation: {
        type: Object,
        default: {},
      },
      evaluators: [],
      show: false,
      filters: {},
    }
  },
  methods: {
    openAddDialog() {
      this.$refs.addDialog.open();
    },
    getEvaluation() {
      this.$api.evaluation.evaluationGet({
        id: this.evaluationId,
      })
        .then(data => {
          this.evaluation = data.evaluation;
        });
    },
    async open(evaluateeId, evaluationId) {
      this.evaluators = [];
      this.isActiveRequest = false;
      this.evaluateeId = evaluateeId;
      this.evaluationId = evaluationId;
      this.loadEvaluators();
      this.getEvaluation();
      this.show = true;
    },
    close() {
      this.show = false;
    },
    loadEvaluators() {
      this.loading = true;
      this.$api.evaluation.evaluatorsSearch({
        ...this.filters,
        types: ['colleague'],
        statuses: this.filters.all ? [] : ['manage_request'],
        evaluatee_id: this.evaluateeId,
        evaluation_id: this.evaluationId,
        expand: ['user'].join(),
        [this.paginator.param]: this.paginator.page,
        [this.paginator.paramPerPage]: this.paginator.perPage,
      })
        .then(({data, paginator}) => {
          this.evaluators = data.evaluators;
          this.paginatorFill(paginator);
        })
        .finally(() => {
          this.loading = false;
        })
    },
    addSelectedRequests(all_confirm = 0, all_reject = 0) {
      this.show = false;

      let newEvaluatorIds = [];
      this.$refs.selectEvaluatorsTable.selection.forEach(evaluator => {
        newEvaluatorIds.push(evaluator.id);
      })

      if (newEvaluatorIds || all_confirm || all_reject) {
        this.$api.evaluation.requestsApprove({
          request_ids: newEvaluatorIds,
          evaluation_id: this.evaluationId,
          user_id: this.evaluateeId,
          all_confirm: all_confirm,
          all_reject: all_reject,
        })
          .then(data => {
            this.$notify.success({
              title: 'Сохранено',
              message: 'Коллеги успешно согласованы'
            });
          })
          .finally(()=>{
            this.loading = false;
            this.$emit('load-requests');
          })
      }
    },
    filtersChanged() {
      this.loadEvaluators();
    },
    checkSelectable(row) {
      return (this.isActiveRequest = (row.status === 'manage_request'));
    },
    getRemainingDays(createdAt, daysLimit) {
      if (!createdAt || !daysLimit) return 0;

      const created = new Date(createdAt);
      const deadline = new Date(created);
      deadline.setDate(deadline.getDate() + daysLimit);

      const now = new Date();
      const diffMs = deadline - now;

      const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));
      return diffDays > 0 ? diffDays : 0;
    }
  }
}
</script>

<style scoped>

</style>